// extracted by mini-css-extract-plugin
module.exports = {"postComment":"PostComment_postComment__EtZvs","postCommentSaveOptions":"PostComment_postCommentSaveOptions__o_n1R"};